import { IconButton, IconClose } from "@cdkglobal/radial";
import { useIntl } from "react-intl";
import { useUIStateContext } from "../../../../contexts/UIStateContext";
import {
  StyledSideSheetTopBar,
  StyledSideSheetTitle,
} from "../../../../utils/styled";
import { closeSideSheet } from "../landing-page-header/landingPageHeader.handlers";

// ---------------------------------------------------------------------------
// SideSheetTopBar
//
// Fixed top bar inside the side sheet.
// Shows the record title on the left and an X close button on the right.
// ---------------------------------------------------------------------------

export default function SideSheetTopBar({
  title,
}: Readonly<{
  title: string;
}>): JSX.Element {
  const intl = useIntl();
  const { setIsSideSheetOpen, setRecordPageToast, setLandingPageToast } =
    useUIStateContext();

  return (
    <StyledSideSheetTopBar>
      <StyledSideSheetTitle>{title}</StyledSideSheetTitle>

      <IconButton
        dataTestId="ss-close-icon-button"
        icon={<IconClose />}
        onClick={() =>
          closeSideSheet({
            setIsSideSheetOpen,
            setRecordPageToast,
            setLandingPageToast,
          })
        }
        aria-label={intl.formatMessage({
          id: "button.close",
          defaultMessage: "Close",
        })}
      />
    </StyledSideSheetTopBar>
  );
}
